import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RoarAssignmentFormService } from '../../../../shared/services/roarAssignmentForm.service';

@Component({
  selector: 'review-roar',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-roar.component.html',
  styleUrl: './review-roar.component.css'
})
export class ReviewRoarComponent implements OnInit {
  
  @Input() roarId: string | null = null;
  
  yesNo = EYesNo;
  roarAssignmentForm: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Classification",
      children: [
        {
          type: 'string',
          questionText: "ROAR Category:",
          answer: "roar_category"
        },
        {
          type: 'string',
          questionText: "ROAR Type:",
          answer: "roar_type"
        },
        {
          type: 'string',
          questionText: "ROAR Details:",
          answer: "roar_details"
        },
        {
          type: 'string',
          questionText: "Administrative Summary (a short description to help identity this ROAR in a list):",
          answer: "administrative_summary"
        }
      ]
    },
    {
      sectionName: "Assigned User",
      children: [
        {
          type: 'string',
          questionText: "User Assigned to this ROAR:",
          answer: "username_assigned"
        }
      ]
    },
    {
      sectionName: "Details",
      children: [
        {
          type: 'string',
          questionText: "Duration:",
          answer: "duration"
        },
        {
          type: 'string',
          questionText: "Frequency:",
          answer: "frequency"
        },
        {
          type: 'string',
          questionText: "How will you know if the intervention is successful?",
          answer: "intervention_success"
        },
        {
          type: 'date',
          questionText: "Estimated Completion Date:",
          answer: "completion_date"
        },
        {
          type: 'string',
          questionText: "Planning Notes:",
          answer: "planning_notes"
        },
        {
          type: 'number',
          questionText: "Does this action require review?",
          answer: "review"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "date_time_signed"
        }
      ]
    },
  ];

  constructor(
    private roarAssignedFormService: RoarAssignmentFormService
  ) { }

  ngOnInit(): void {
    this.loadRoarAssignmentForm();
  }

  loadRoarAssignmentForm(): void {
    if (this.roarId) {
      this.loading = true;
      this.roarAssignedFormService.getRoarAssignmentFormByRoarId(this.roarId).subscribe({
        next: (response) => {
          if (Object.keys(response).length === 0) {
            this.roarAssignmentForm = null;
            this.loading = false;
            return
          } else {
            this.roarAssignmentForm = response;
            this.loading = false;
            return
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
  }


  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
